module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e34dcf9a3e10ded30209b07f84db139c.gif";